import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-toast_ic_complete",
  "use": "icon-toast_ic_complete-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-toast_ic_complete\"><clipPath id=\"icon-toast_ic_complete_a\"><path d=\"m0 0h24v24h-24z\" /></clipPath><g clip-path=\"url(#icon-toast_ic_complete_a)\" fill=\"#fff\"><path d=\"m12 23c-6.1 0-11-4.9-11-11s4.9-11 11-11 11 4.9 11 11-4.9 11-11 11zm0-20c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9z\" /><path d=\"m10.6 16.3c-.4 0-.8-.2-1.1-.4l-3.2-3.2c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l2.9 2.9 5.7-5.7c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-6 6c-.3.2-.7.4-1.1.4z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/toast_ic_complete.svg
// module id = /UUe
// module chunks = 87